import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (financialYearId) => {
	return fetch(
		Methods.GET,
		EndPoints.FINANCIAL_YEAR_RESULT.replace(':year', financialYearId),
		null,
		null,
		true
	);
};
